import { render } from "./UserProfileSecurity.vue?vue&type=template&id=134d6e9b"
import script from "./UserProfileSecurity.vue?vue&type=script&lang=js"
export * from "./UserProfileSecurity.vue?vue&type=script&lang=js"
script.render = render

export default script